import React from 'react'
import { Container } from "react-bootstrap";
import Particle from '../components/Particle';
import '../index.css'
const Education = () => {
    return (
        <Container style={{ padding: '60px' }}>
            <Particle />
            <Container>
                <h1 className="project-heading mt-5">
                    Education <strong className="yellow">Details </strong>
                </h1>
                <div class="timeline">
                    <div class="outer">
                        <div class="card">
                            <div class="info">
                                <h3 class="title">10th</h3>
                                <p><strong>Board:</strong> Board of Secondary Education, Assam.</p>
                                <p><strong>School:</strong> Oil India Higher Secondary School.</p>
                                <p><strong>Percentage:</strong> 85.83%</p>
                            </div>
                        </div>
                        <div class="card">
                            <div class="info">
                                <h3 class="title">12th</h3>
                                <p><strong>Board: </strong>Assam Higher Secondary Education Council.</p>
                                <p><strong>School: </strong>Oil India Higher Secondary School.</p>
                                <p><strong>Percentage:</strong>75%</p>
                            </div>
                        </div>
                        <div class="card">
                            <div class="info">
                                <h3 class="title">Bachelor of Engineering</h3>
                                <p><strong>College:</strong>Dayananda Sagar Academy of Technology and Management</p>
                                <p><strong>CGPA:</strong> 8.4</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </Container>
    )
}

export default Education
